import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, LayoutGrid, Calculator, Handshake, ArrowUpRight, Sparkles, Rocket } from "lucide-react";
import { LinkShell, waLink, fadeUp } from "./LinkShell";

const BUTTONS = [
  { id: "konsultasi", title: "Konsultasi Aplikasi Custom", sub: "Ceritakan kebutuhan bisnismu via WhatsApp", icon: MessageCircle, href: waLink("Halo, saya ingin konsultasi aplikasi custom untuk bisnis saya."), highlight: true },
  { id: "solusi", title: "Lihat Solusi yang Bisa Dibangun", sub: "Dashboard • CRM • Sistem Operasional • Automasi", icon: LayoutGrid, to: "/link/solusi" },
  { id: "estimasi", title: "Minta Estimasi Project", sub: "Diskusikan scope, fitur, dan kebutuhan aplikasi", icon: Calculator, to: "/link/estimasi" },
  { id: "partnership", title: "Kolaborasi & Partnership", sub: "Untuk project digital dan pengembangan produk", icon: Handshake, href: waLink("Halo, saya tertarik untuk kolaborasi & partnership.") },
];

function LinkButton({ b }) {
  const Icon = b.icon;
  const cls = `group flex items-center gap-4 rounded-2xl border px-4 py-4 transition-[transform,box-shadow,background-color,border-color] duration-200 hover:-translate-y-0.5 active:translate-y-0 ${
    b.highlight
      ? "border-lime-500 bg-lime-400 text-zinc-950 shadow-[0_10px_30px_-10px_rgba(132,204,22,0.7)] hover:bg-lime-300"
      : "border-zinc-200 bg-white hover:border-lime-400 hover:shadow-[0_10px_30px_-15px_rgba(24,24,27,0.25)]"
  }`;
  const inner = (
    <>
      <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${b.highlight ? "bg-zinc-950 text-lime-300" : "bg-lime-100 text-lime-700"}`}>
        <Icon className="h-5 w-5" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-bold leading-snug">{b.title}</span>
        <span className={`mt-0.5 block text-xs ${b.highlight ? "text-zinc-800" : "text-zinc-500"}`}>{b.sub}</span>
      </span>
      <ArrowUpRight className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </>
  );
  return b.to ? (
    <Link to={b.to} data-testid={`link-btn-${b.id}`} className={cls}>{inner}</Link>
  ) : (
    <a href={b.href} target="_blank" rel="noopener noreferrer" data-testid={`link-btn-${b.id}`} className={cls}>{inner}</a>
  );
}

function BuildCard() {
  return (
    <div data-testid="link-build-card" className="relative overflow-hidden rounded-3xl bg-zinc-950 p-6 text-white">
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-lime-400/20 blur-3xl" />
      <span data-testid="link-build-badge" className="inline-flex items-center gap-1.5 rounded-full border border-lime-400/40 bg-lime-400/10 px-3 py-1 text-[11px] font-bold tracking-[0.18em] text-lime-300">
        <Sparkles className="h-3 w-3" /> LEARN • BUILD • LAUNCH
      </span>
      <h2 className="mt-4 text-2xl font-extrabold tracking-tight">Build Your Own App <span className="text-lime-400">with AI</span></h2>
      <p className="mt-2 text-sm leading-relaxed text-zinc-300">
        Punya ide aplikasi sendiri? Belajar bangun aplikasi dengan AI, mulai dari nol hingga jadi produk digital.
      </p>
      <a
        href={waLink("Halo, saya ingin mulai bangun aplikasi sendiri dengan AI.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="link-build-cta"
        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-lime-400 px-5 py-3 text-sm font-bold text-zinc-950 transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-lime-300"
      >
        <Rocket className="h-4 w-4" /> Mulai Bangun Aplikasimu
      </a>
    </div>
  );
}

export default function LinkHome() {
  return (
    <LinkShell testId="link-home-page">
      <header className="text-left" {...fadeUp(0)}>
        <div className="flex h-20 w-20 items-center justify-center rounded-3xl bg-zinc-950 text-2xl font-extrabold text-lime-400 shadow-[0_15px_40px_-15px_rgba(24,24,27,0.6)]">AI</div>
        <h1 data-testid="link-name" className="mt-5 text-3xl font-extrabold tracking-tight sm:text-4xl">AI Business Builder</h1>
        <p data-testid="link-handle" className="mt-1 text-sm font-semibold text-lime-700">@mudahcarikerja</p>
        <p data-testid="link-tagline" className="mt-4 text-base font-medium text-zinc-700">Turning business problems into digital solutions.</p>
        <p data-testid="link-subtagline" className="mt-2 text-xs font-semibold uppercase tracking-wider text-zinc-500">Custom Apps • AI Solutions • Business Automation</p>
      </header>
      <nav className="mt-8 space-y-3">
        {BUTTONS.map((b, i) => (
          <div key={b.id} {...fadeUp(i + 1)}><LinkButton b={b} /></div>
        ))}
      </nav>
      <div {...fadeUp(6, "mt-6")}><BuildCard /></div>
    </LinkShell>
  );
}
